export default [
    {
        // 图标解释标题
        title: $t('integration.base_type'),
        // 图标类型
        type: 'baseType'
    },
    {
        title: $t('integration.base_binding_status'),
        type: 'baseBindStatus'
    }
];
